/**
 * ContactSupportSection
 *
 * Section 1 of the Contact page: a "Check the Support section if you need
 * help" pointer with a tappable Support link. The link navigates to the
 * Support page via `Navigator.navigateToSupport()`, matching Flutter's
 * `ContactScreen` (`contact_screen.dart:101-103` →
 * `NavigationService.navigateToSupportScreen()`).
 *
 * Co-located with `ContactPage` to keep the page under the ~200-line
 * Should-Fix threshold from `presentation.md`.
 */
import { useTheme } from '@/presentation/contexts/ThemeContext';
import { useResponsiveDesign } from '@/presentation/responsiveDesign/responsiveDesign';
import { useLocale } from '@/presentation/contexts/LocaleContext';
import { Navigator } from '@/presentation/routing/Navigator';
import { ExpauseButton, ButtonVariant } from '@/presentation/components/common/controls/ExpauseButton';
import { qaAttr } from '@/presentation/utils/qaAttr';

export const ContactSupportSection = () => {
    const { theme } = useTheme();
    const responsive = useResponsiveDesign();
    const { l10n } = useLocale();

    const handleSupportLinkTap = () => {
        Navigator.navigateToSupport();
    };

    return (
        <section
            style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
            }}
        >
            <p
                style={{
                    margin: 0,
                    marginBottom: responsive.spacing.sm,
                    color: theme.text.primary,
                    fontSize: responsive.font.base,
                    fontWeight: responsive.fontWeight.semibold,
                    textAlign: 'center',
                }}
            >
                {l10n.contact.supportSectionLabel}
            </p>
            <ExpauseButton
                {...qaAttr({ id: 'contact-support' })}
                variant={ButtonVariant.text}
                textColor={theme.blue}
                onClick={handleSupportLinkTap}
                style={{
                    fontSize: responsive.font.base,
                    fontFamily: 'inherit',
                }}
            >
                {l10n.contact.supportLink}
            </ExpauseButton>
        </section>
    );
};
